define([
	"dojo/_base/declare",
	"csi/table/Widget"
], function(declare,Widget) {

	return declare(Widget, {
		disableCustomViewToolbar: true,
		displayGlobalAssignments: false,

		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: if showing revised values, then query for review data
			var	ql = this.inherited(arguments);
			if (ql.bMain) {
				ql.requestParameters = {
					"Crew": this.urlRoot,
					"IncludeEmpty": false,
					"IncludeGlobal": this.displayGlobalAssignments
				};
			}
			
			return ql;
		},
		
		_resetStores: function() {
			// summary: clean up old reports
			var cache = this.cacheView;

			cache.query({"$Type":"CrewAssignmentReport"}).forEach(function(node) {
				cache.remove(node.$URL);
			});
			
			this.inherited(arguments);
		}
	});
});